module.exports = __webpack_public_path__ + "img/php.75c859f8.png";